import React from "react";
import ServiceList from "./ServiceList";


const BaseTamplate = (props) => {
    return (
        <div>
            {/* Main Title image */}
            <div className="hide-on-med-and-up">
                <div class='col s6'>
                    <div class="card">
                        <div class="card-image waves-effect waves-block waves-light">
                            <img className="activator" src={props.children}></img>
                        </div>
                    </div>
                </div>

            </div>

            {/* Services Offered list  */}
            <div className="hide-on-small-only">
                <div class="row">
                    <div class='col s6'>
                        <div class="card">
                            <div class="card-image waves-effect waves-block waves-light">
                                <img class="activator" src={props.children}></img>
                            </div>
                        </div>
                    </div>

                    <div class="col s6">
                        <div className="container">
                            <div><h3>{props.pageName}</h3></div>
                            <ServiceList Title = {props.Title} itemList={props.itemList}></ServiceList>
                        </div>
                    </div>
                </div>

                {/* 2 X 3 Grid of pictures */}
                <div className='row'>
                    <div class="col s12">
                        <div class="card">

                            <div class="col s4">
                                <div class="card">
                                    <div class="card-image waves-effect waves-block waves-light">
                                        <img class="activator responsive-img" src={props.pictures[0]}></img>
                                    </div>
                                </div>
                            </div>
                            <div class="col s4">
                                <div class="card">
                                    <div class="card-image waves-effect waves-block waves-light">
                                        <img class="activator responsive-img" src={props.pictures[1]}></img>
                                    </div>
                                </div>
                            </div>

                            <div class="col s4">
                                <div class="card">
                                    <div class="card-image waves-effect waves-block waves-light">
                                        <img class="activator responsive-img" src={props.pictures[2]}></img>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div class="col s12">
                        <div class="card">

                            <div class="col s4">
                                <div class="card">
                                    <div class="card-image waves-effect waves-block waves-light">
                                        <img class="activator responsive-img" src={props.pictures[3]}></img>
                                    </div>
                                </div>
                            </div>
                            <div class="col s4">
                                <div class="card">
                                    <div class="card-image waves-effect waves-block waves-light">
                                        <img class="activator responsive-img" src={props.pictures[4]}></img>
                                    </div>
                                </div>
                            </div>

                            <div class="col s4">
                                <div class="card">
                                    <div class="card-image waves-effect waves-block waves-light">
                                        <img class="activator responsive-img" src={props.pictures[5]}></img>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            {/* For the mobile version */}

            <div className="hide-on-med-and-up">
                <div>

                    <div class="col s6">
                        <div className="container">
                            <div><h3>{props.pageName}</h3></div>
                            <ServiceList Title = {props.Title} itemList={props.itemList}></ServiceList>
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div class="col s12">
                        <div class="card">

                            <div class="col s4">
                                <div class="card">
                                    <div class="card-image waves-effect waves-block waves-light">
                                        <img class="activator responsive-img" src={props.pictures[0]}></img>
                                    </div>
                                </div>
                            </div>
                            <div class="col s4">
                                <div class="card">
                                    <div class="card-image waves-effect waves-block waves-light">
                                        <img class="activator responsive-img" src={props.pictures[1]}></img>
                                    </div>
                                </div>
                            </div>

                            <div class="col s4">
                                <div class="card">
                                    <div class="card-image waves-effect waves-block waves-light">
                                        <img class="activator responsive-img" src={props.pictures[2]}></img>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div class="col s12">
                        <div class="card">

                            <div class="col s4">
                                <div class="card">
                                    <div class="card-image waves-effect waves-block waves-light">
                                        <img class="activator responsive-img" src={props.pictures[3]}></img>
                                    </div>
                                </div>
                            </div>
                            <div class="col s4">
                                <div class="card">
                                    <div class="card-image waves-effect waves-block waves-light">
                                        <img class="activator responsive-img" src={props.pictures[4]}></img>
                                    </div>
                                </div>
                            </div>

                            <div class="col s4">
                                <div class="card">
                                    <div class="card-image waves-effect waves-block waves-light">
                                        <img class="activator responsive-img" src={props.pictures[5]}></img>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}



export default BaseTamplate;